// src/pages/ForgotPasswordPage.jsx
import { useState } from 'react';
import axios from '../api/axiosClient';

export default function ForgotPasswordPage() {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage(''); // clear old messages
        try {
            const res = await axios.post('/auth/forgot-password', { email: email.trim() });

            if (res.status === 200) {
                setMessage('A reset link has been sent to your email.');
            } else {
                setMessage('Something went wrong.');
            }
        } catch (err) {
            console.error(err);
            setMessage(err.response?.data?.message || 'Something went wrong.');
        }
    };


    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4">
            <form onSubmit={handleSubmit} className="bg-white p-8 rounded shadow-md w-full max-w-md">
                <h2 className="text-xl font-bold mb-4 text-center">Forgot Password</h2>
                <input
                    type="email"
                    placeholder="Enter your email"
                    className="w-full p-2 border rounded mb-4"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                />
                <button type="submit" className="w-full bg-gold text-white py-2 rounded hover:bg-[#b88e2e]">
                    Send Reset Link
                </button>
                {message && <p className="text-center text-sm mt-4">{message}</p>}
            </form>
        </div>
    );
}
